module.exports = __webpack_public_path__ + "img/4902720092085_1.4ab9971e.png";